import React, { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CountUp from "react-countup";
import Confetti from "react-confetti";

import { Milestones } from "../ui";

const CampaignInfo = (props) => {
  const [completed, setCompleted] = useState(false);

  const { overallprogress } = props.eventStore;

  const checkComplete = () => {
    const { overallprogress } = props.eventStore;
    if (overallprogress >= 100) {
      setCompleted(true);
      setTimeout(() => {
        setCompleted(false);
        setTimeout(checkComplete, 30000);
      }, 15000);
      console.log("complete");
    } else {
      setCompleted(false);
      setTimeout(checkComplete, 10000);
      console.log('not complete')
    }
  };

  useEffect(() => {
    setTimeout(checkComplete, 10000);
  }, []);

  //console.log(campaign, goal, raised, progress);
  return (
    <div className="therm-container" id="therm">
      {/* {milestones.length && progress < 100 ? */}
      <Milestones />
      {/* :
          ""
        } */}

      <div>
        {overallprogress === 100 ? (
          
            <Routes>
              <Route path="/classic" element={
                <Confetti
                  width={1015}
                  height={55}
                  numberOfPieces={50}
                  gravity={0.3}
                  colors={[
                    "#8332a7",
                    "#1874dc",
                    "#64d0e4",
                    "#c0da07",
                    "#ffc32c",
                    "#490e67",
                    "#002856",
                    "#1eadc1",
                    "#75bc21",
                    "#ffb125",
                    "#c10f3a",
                  ]}
                />}/>
              <Route path="/slanted" element={
                <Confetti
                  width={995}
                  height={55}
                  numberOfPieces={50}
                  gravity={0.3}
                  colors={[
                    "#8332a7",
                    "#1874dc",
                    "#64d0e4",
                    "#c0da07",
                    "#ffc32c",
                    "#490e67",
                    "#002856",
                    "#1eadc1",
                    "#75bc21",
                    "#ffb125",
                    "#c10f3a",
                  ]}
                />}/>
              <Route path="/event-max" element={
                <Confetti
                  width={1750}
                  height={60}
                  numberOfPieces={50}
                  gravity={0.3}
                  colors={[
                    "#8332a7",
                    "#1874dc",
                    "#64d0e4",
                    "#c0da07",
                    "#ffc32c",
                    "#490e67",
                    "#002856",
                    "#1eadc1",
                    "#75bc21",
                    "#ffb125",
                    "#c10f3a",
                  ]}
                />}/>
            </Routes>
          
        ) : (
          ""
        )}
        {completed ? (
          <div className="therm-container__completed">
            <div className="therm-container__completed__goal">
              <span>G</span>
              <span>O</span>
              <span>A</span>
              <span>L</span>
              <span className="completed_space">M</span>
              <span>E</span>
              <span>T</span>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {props.bgColor === "game-theorist" ? (
        <div className="therm-container__glass"></div>
      ) : (
        ""
      )}

      <p className="therm-container__raised">
        $
        <CountUp
          end={props.raised}
          duration={1}
          separator=","
          decimals={props.raised - Math.floor(props.raised) !== 0 ? 2 : 0}
          preserveValue={true}
          useEasing={false}
        />{" "}
        Raised
      </p>
      <div
        id="therm-container__expand"
        className={`
            ${
              props.progress <= 0
                ? "therm-container__inner no-point"
                : "therm-container__inner point"
            }
            ${props.bgColor}
            ${props.progress >= 80 ? "m-higher" : ""}
          `}
        style={{
          width: `
              ${props.progress}%
            `,
        }}
      ></div>
      {props.bgColor === "game-theorist" ? (
        <div
          className="therm-container__inner__back"
          style={{
            width: `
                ${props.progress}%
              `,
          }}
        />
      ) : (
        ""
      )}
      <p className="therm-container__goal">Goal: ${props.goal}</p>
    </div>
  );
};

export default inject("eventStore")(observer(CampaignInfo));
